import { StyleSheet, Dimensions, Platform } from 'react-native';

import { isIPhoneDeviceWithNotch } from '@vfgroup-oneplatform/foundation/Utils/Platform';

const screenWidth = Dimensions.get('window').width;

const isIPhoneWithNotch = isIPhoneDeviceWithNotch();

const isAndroid = Platform.OS === 'android';

export default StyleSheet.create({
  btnSuccess: {
    borderWidth: 0,
  },
  btnReject: theme => ({
    marginTop: 16.2,
  }),
  btnsContainer: {
    marginTop: isAndroid || isIPhoneWithNotch ? 20 : 19,
    marginBottom: isAndroid ? 0 : -27,
  },
  footerContainer: isVoucherTopUp => ({
    width: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? '100%' : '90%',
    marginHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 16,
    marginTop: 25,
    paddingRight: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 0
  }),
  successBtnDisabled: theme => ({
    backgroundColor: theme.colors.buttons.disabled,
  }),
  successBtnDisabledText: theme => ({
    color: theme.colors.textButtons.tertiary.default,
  }),
  widthAdjustment: {
    // width: screenWidth - 32,
    marginHorizontal: 16,
  },
});
